
import u from "umbrellajs"

import YahooGemini_Conversions from "app/tracking/yahoo_gemini/conversions"

interface Selector {
  scope:  string | HTMLElement
  btn:    string
}
interface InputSelector {
  scope?:  string | HTMLElement
  btn?:    string
}
const DEFAULT_SELECTOR = {
  scope:  ".cell-new-development-contact-request-box",
  btn:    ".cell-new-development-contact-request-box__btn-submit",
}
const init = (selector?: InputSelector) => {
  const sele = Object.assign({}, DEFAULT_SELECTOR, selector)
  const $scope = u(sele.scope)
  const $btn = $scope.find(sele.btn)

  $btn.on("click", () => {
    YahooGemini_Conversions.SendSpaciousEnquiry.track()
  })
}

export default {init}

